import { Divider, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { KeyPrefixValues } from "./ImportFromFileErrorsTable";


interface Data {
    numberOfTotalRows:number;
    numberOfErrorRowsInsert:number;
    numberOfSuccessRowInsert:number
}

type ErrorsImportToolbarInfoProps = Data & {keyPrefix:KeyPrefixValues}



export const ErrorsImportToolbarInfo:React.FC<ErrorsImportToolbarInfoProps> = ({numberOfTotalRows,numberOfErrorRowsInsert,numberOfSuccessRowInsert,keyPrefix}:ErrorsImportToolbarInfoProps) => {

    const {t} = useTranslation(['salesmarketing'], {keyPrefix});

    return (
        <Stack direction="row" alignItems="center" columnGap={1.5} px={2} pb={1} overflow="hidden">
            <Stack direction="row" alignItems="center" columnGap={1}>
                <Typography variant="caption" >{ `${keyPrefix === 'poi' ? t('ImportPoiToolbarInfoLabels.numberOfInsertedPoi') : t('ImportVoucherToolbarInfoLabels.numberOfInsertedVoucher') }`}:</Typography>
                <Typography variant="caption">{numberOfTotalRows}</Typography>
            </Stack>
            
            <Stack direction="row" alignItems="center" columnGap={1} >
                <Typography variant="caption">{ `${keyPrefix === 'poi' ? t('ImportPoiToolbarInfoLabels.numberOfSuccessInPoiInsert') : t('ImportVoucherToolbarInfoLabels.numberOfSuccessInVoucherInsert') }`}:</Typography>
                <Typography variant="caption">{numberOfSuccessRowInsert}</Typography>
            </Stack>
            
            <Stack direction="row" alignItems="center" columnGap={1}>
                <Typography variant="caption">{ `${keyPrefix === 'poi' ? t('ImportPoiToolbarInfoLabels.numberOfErrorInPoiInsert') :t('ImportVoucherToolbarInfoLabels.numberOfErrorInVoucherInsert')}`}:</Typography>
                <Typography variant="caption">{numberOfErrorRowsInsert}</Typography>
            </Stack>
        </Stack>
    );
};

